import { cn } from "@frontend/shared/lib/utils";
import type { AspectRatio } from "./types";

// Container styles based on aspectRatio
export const getContainerStyles = (aspectRatio: AspectRatio) => {
  const baseStyles = "w-full";

  if (aspectRatio === "cover") {
    return cn(baseStyles, "absolute bottom-0 top-0 left-0 right-0");
  }

  // For other aspect ratios, calculate the padding dynamically
  // Note: We'll need to apply this padding inline since Tailwind
  // doesn't support dynamic values
  return baseStyles;
};

// Camera video element styles
export const getCameraStyles = (mirrored: boolean) => {
  return cn(
    "w-full h-full object-cover z-0",
    mirrored ? "scale-x-[-1]" : "", // Using scale-x-[-1] instead of rotateY for better performance
  );
};

// Canvas styles
export const canvasStyles = "hidden";
